import { BlogPost } from 'containers/blog/post/types';

export const getBlogPost = (id: string, blogPosts: BlogPost[]): BlogPost => {
  const post = blogPosts.find(({ id: postId }) => postId === id);

  if (!post) {
    throw new Error(`Invalid post id ${id}`);
  }
  return post;
};
